import { Record } from "immutable";
import { currentDateTime } from "core/datetime";

const defaultModel = {
  url: "",
  id: 0,
  case: null,
  machine: null,
  component: null,
  date_time: currentDateTime(),
  type: 1,
  description: "",
  attachments: [],
  __rawAttachments: [],
  recommendation: "",
  params: {}
};
const EventModelStateRecord = Record(defaultModel);

class EventModelState {
  _immutable;

  static createEmpty() {
    return EventModelState.create({
      currentContent: { date_time: new Date() }
    });
  }

  static createWithContent(existingCaseData) {
    return EventModelState.create({ currentContent: existingCaseData });
  }

  static create(config) {
    const { currentContent } = config;
    return new EventModelState(new EventModelStateRecord(currentContent));
  }

  static set(eventModelState, put) {
    const map = eventModelState.getImmutable().withMutations(state => {
      state.merge(put);
    });
    return new EventModelState(map);
  }

  constructor(immutable) {
    this._immutable = immutable;
  }

  getImmutable() {
    return this._immutable;
  }

  getMutable() {
    return this.getImmutable().asMutable();
  }

  toJS() {
    return this.getImmutable().toJS();
  }
}

export default EventModelState;
